import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material';
import { RemoteService } from 'app/services/remote.service';
import { LocalStorageService } from 'ngx-store';
@Component({
  selector: 'app-subscription-pricing',
  templateUrl: './subscription-pricing.component.html',
  styleUrls: ['./subscription-pricing.component.scss']
})
export class SubscriptionPricingComponent implements OnInit {
  displayedColumns: string[] = ['comparePlans', 'freePlan', 'starterPlan'];
  dataSource = new MatTableDataSource();
  displayedColumns1: string[] = ['portfolioFeatures', 'freePlan', 'starterPlan'];
  dataSource1 = new MatTableDataSource();
  displayedColumns2: string[] = ['reports', 'freePlan', 'starterPlan'];
  dataSource2 = new MatTableDataSource();
  upgradeData = [
    {
      comparePlans: 'Portfolios',
      freePlan: 1,
      starterPlan: 10,
      investorPlan: 3,
      expertPlan: 3
    },
    {
      comparePlans: 'Holdings',
      freePlan: 15,
      starterPlan: "Unlimited",
      investorPlan: "Unlimited",
      expertPlan: "Unlimited"
    }
  ]
  upgradeData1 = [
    {
      portfolioFeatures: 'Automatic Dividends & Adjustments',
      freePlan: true,
      starterPlan: true,
      investorPlan: true,
      expertPlan: true
    },
    {
      portfolioFeatures: 'Stock Splits / Reverse Splits Integeration',
      freePlan: true,
      starterPlan: true,
      investorPlan: true,
      expertPlan: true
    },
    {
      portfolioFeatures: 'Dividend Integeration',
      freePlan: true,
      starterPlan: true,
      investorPlan: true,
      expertPlan: true
    },
    {
      portfolioFeatures: 'Portfolio Management',
      freePlan: true,
      starterPlan: true,
      investorPlan: true,
      expertPlan: true
    },
    {
      portfolioFeatures: 'Trade Management',
      freePlan: true,
      starterPlan: true,
      investorPlan: true,
      expertPlan: true
    },
    {
      portfolioFeatures: 'Portfolio Re-Balancing',
      freePlan: false,
      starterPlan: true,
      investorPlan: true,
      expertPlan: true
    },
    {
      portfolioFeatures: 'Portfolio Sharing',
      freePlan: false,
      starterPlan: true,
      investorPlan: true,
      expertPlan: true
    },
    {
      portfolioFeatures: 'Cash Accounts',
      freePlan: false,
      starterPlan: true,
      investorPlan: true,
      expertPlan: true
    },
    {
      portfolioFeatures: 'File Attachments',
      freePlan: false,
      starterPlan: true,
      investorPlan: true,
      expertPlan: true
    },
    {
      portfolioFeatures: 'Multiple Portfolio Per User',
      freePlan: false,
      starterPlan: true,
      investorPlan: true,
      expertPlan: true
    },
    {
      portfolioFeatures: 'File Attachment option per Trade',
      freePlan: false,
      starterPlan: true,
      investorPlan: true,
      expertPlan: true
    },
    {
      portfolioFeatures: 'Advanced Reporting',
      freePlan: false,
      starterPlan: true,
      investorPlan: true,
      expertPlan: true
    },
    {
      portfolioFeatures: 'Analytics',
      freePlan: false,
      starterPlan: true,
      investorPlan: true,
      expertPlan: true
    },
    {
      portfolioFeatures: 'Comparisons',
      freePlan: false,
      starterPlan: true,
      investorPlan: true,
      expertPlan: true
    },
    {
      portfolioFeatures: 'Cash Management',
      freePlan: false,
      starterPlan: true,
      investorPlan: true,
      expertPlan: true
    },
    {
      portfolioFeatures: 'Integration with a flagship client',
      freePlan: false,
      starterPlan: true,
      investorPlan: true,
      expertPlan: true
    },
    {
      portfolioFeatures: 'Volatility calculations, return calculations',
      freePlan: false,
      starterPlan: true,
      investorPlan: true,
      expertPlan: true
    },
    {
      portfolioFeatures: 'Risk, Reward Calculations',
      freePlan: false,
      starterPlan: true,
      investorPlan: true,
      expertPlan: true
    },
    {
      portfolioFeatures: 'Modern Portfolio theory',
      freePlan: false,
      starterPlan: true,
      investorPlan: true,
      expertPlan: true
    },
    {
      portfolioFeatures: 'Sector-based analysis and reporting',
      freePlan: false,
      starterPlan: true,
      investorPlan: true,
      expertPlan: true
    }
  ]
  upgradeData2 = [
    {
      reports: 'Performance',
      freePlan: false,
      starterPlan: true,
      investorPlan: 3,
      expertPlan: 3
    },
    {
      reports: 'All Trades',
      freePlan: false,
      starterPlan: true,
      investorPlan: 3,
      expertPlan: 3
    }
  ]
  showFeatureDetails: boolean;
  constructor(private remoteService: RemoteService,
    private ls: LocalStorageService) { }

  ngOnInit() {
    this.dataSource = new MatTableDataSource(this.upgradeData);
    this.dataSource1 = new MatTableDataSource(this.upgradeData1);
    this.dataSource2 = new MatTableDataSource(this.upgradeData2);
    if (this.ls.get('access_token')) {
      return this.remoteService.userNavigateTodashboard();
    }
    this.remoteService.scrollingtoNavbar();
  }

  clickFeatureDetails() {
    this.showFeatureDetails = !this.showFeatureDetails;
  }

}
